export const stateOptions = [
    { value: 'AL', label: 'Alabama', alternate: ['Alabama'] },
    { value: 'AK', label: 'Alaska', alternate: ['Alaska'] },
    { value: 'AS', label: 'American Samoa', alternate: ['American Samoa'] },
    { value: 'AZ', label: 'Arizona', alternate: ['Arizona'] },
    { value: 'AR', label: 'Arkansas', alternate: ['Arkansas'] },
    { value: 'CA', label: 'California', alternate: ['California'] },
    { value: 'CO', label: 'Colorado', alternate: ['Colorado'] },
    { value: 'CT', label: 'Connecticut', alternate: ['Connecticut'] },
    { value: 'DE', label: 'Delaware', alternate: ['Delaware'] },
    { value: 'FM', label: 'Micronesia', alternate: ['Federated States of Micronesia', 'Micronesia'] },
    { value: 'FL', label: 'Florida', alternate: ['Florida'] },
    { value: 'GA', label: 'Georgia', alternate: ['Georgia'] },
    { value: 'GU', label: 'Guam', alternate: ['Guam'] },
    { value: 'HI', label: 'Hawaii', alternate: ['Hawaii'] },
    { value: 'ID', label: 'Idaho', alternate: ['Idaho'] },
    { value: 'IL', label: 'Illinois', alternate: ['Illinois'] },
    { value: 'IN', label: 'Indiana', alternate: ['Indiana'] },
    { value: 'IA', label: 'Iowa', alternate: ['Iowa'] },
    { value: 'KS', label: 'Kansas', alternate: ['Kansas'] },
    { value: 'KY', label: 'Kentucky', alternate: ['Kentucky'] },
    { value: 'LA', label: 'Louisiana', alternate: ['Louisiana'] },
    { value: 'ME', label: 'Maine', alternate: ['Maine'] },
    { value: 'MH', label: 'Marshall Islands', alternate: ['Marshall Islands'] },
    { value: 'MD', label: 'Maryland', alternate: ['Maryland'] },
    { value: 'MA', label: 'Massachusetts', alternate: ['Massachusetts'] },
    { value: 'MI', label: 'Michigan', alternate: ['Michigan'] },
    { value: 'MN', label: 'Minnesota', alternate: ['Minnesota'] },
    { value: 'MS', label: 'Mississippi', alternate: ['Mississippi'] },
    { value: 'MO', label: 'Missouri', alternate: ['Missouri'] },
    { value: 'MT', label: 'Montana', alternate: ['Montana'] },
    { value: 'NE', label: 'Nebraska', alternate: ['Nebraska'] },
    { value: 'NV', label: 'Nevada', alternate: ['Nevada'] },
    { value: 'NH', label: 'New Hampshire', alternate: ['New Hampshire'] },
    { value: 'NJ', label: 'New Jersey', alternate: ['New Jersey'] },
    { value: 'NM', label: 'New Mexico', alternate: ['New Mexico'] },
    { value: 'NY', label: 'New York', alternate: ['New York'] },
    { value: 'NC', label: 'North Carolina', alternate: ['North Carolina'] },
    { value: 'ND', label: 'North Dakota', alternate: ['North Dakota'] },
    { value: 'MP', label: 'Northern Mariana Islands', alternate: ['Northern Mariana Islands'] },
    { value: 'OH', label: 'Ohio', alternate: ['Ohio'] },
    { value: 'OK', label: 'Oklahoma', alternate: ['Oklahoma'] },
    { value: 'OR', label: 'Oregon', alternate: ['Oregon'] },
    { value: 'PW', label: 'Palau', alternate: ['Palau'] },
    { value: 'PA', label: 'Pennsylvania', alternate: ['Pennsylvania'] },
    { value: 'PR', label: 'Puerto Rico', alternate: ['Puerto Rico'] },
    { value: 'RI', label: 'Rhode Island', alternate: ['Rhode Island'] },
    { value: 'SC', label: 'South Carolina', alternate: ['South Carolina'] },
    { value: 'SD', label: 'South Dakota', alternate: ['South Dakota'] },
    { value: 'TN', label: 'Tennessee', alternate: ['Tennessee'] },
    { value: 'TX', label: 'Texas', alternate: ['Texas'] },
    { value: 'UT', label: 'Utah', alternate: ['Utah'] },
    { value: 'VT', label: 'Vermont', alternate: ['Vermont'] },
    { value: 'VA', label: 'Virginia', alternate: ['Virginia'] },
    { value: 'WA', label: 'Washington', alternate: ['Washington'] },
    { value: 'DC', label: 'Washington DC', alternate: ['District of Columbia', 'Washington DC'] },
    { value: 'WV', label: 'West Virginia', alternate: ['West Virginia'] },
    { value: 'WI', label: 'Wisconsin', alternate: ['Wisconsin'] },
    { value: 'WY', label: 'Wyoming', alternate: ['Wyoming'] },
    { value: 'VI', label: 'U.S. Virgin Islands', alternate: ['Virgin Islands', 'U.S. Virgin Islands'] },
    { value: 'AA', label: 'Armed Forces Americas', alternate: ['Armed Forces Americas'] },
    { value: 'AE', label: 'Armed Forces Europe', alternate: ['Armed Forces Europe'] },
    { value: 'AP', label: 'Armed Forces Pacific', alternate: ['Armed Forces Pacific'] },
  ];